import { render, staticRenderFns } from "./VisaHistory.vue?vue&type=template&id=561252ac&scoped=true&"
import script from "./VisaHistory.vue?vue&type=script&lang=js&"
export * from "./VisaHistory.vue?vue&type=script&lang=js&"
import style0 from "./VisaHistory.vue?vue&type=style&index=0&id=561252ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561252ac",
  null
  
)

export default component.exports